"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDetermineFilteredListItems = void 0;
var react_1 = require("react");
var shared_1 = require("../../shared");
var shared_2 = require("./shared");
var useDetermineFilteredListItems = function (useCheckboxSelection) {
    var _a = (0, react_1.useState)([]), listItems = _a[0], setListItems = _a[1];
    var _b = (0, react_1.useState)(0), filteredAnchoredItemsCount = _b[0], setFilteredAnchoredItemsCount = _b[1];
    /**
     * Filter items based on input value
     * @param filterParams - object of items needed to filter correctly
     * @param inputText - value from the `input` element
     * @param currentlySelected - `selectedItem(s)` set by Downshift
     */
    var updateFilteredListboxItems = function (filterParams, inputText, currentlySelected) {
        var _a = filterParams.itemIsAnchored, itemIsAnchored = _a === void 0 ? function () { return false; } : _a, _b = filterParams.items, items = _b === void 0 ? [] : _b, itemToID = filterParams.itemToID, renderItemToString = filterParams.renderItemToString;
        var isSelectedAnArray = Array.isArray(currentlySelected);
        var inputValueRegex = new RegExp((0, shared_1.escapeString)(inputText), 'i');
        var anchoredItems = [];
        var nonAnchoredItems = [];
        var safelyCallItemToID = function (listboxItem) {
            return (0, shared_2.setupSafelyCallItemToID)(itemToID, renderItemToString, listboxItem);
        };
        var customCreatedItems = [];
        if (isSelectedAnArray && currentlySelected.length && typeof currentlySelected[0] === 'object') {
            // @ts-expect-error - Already mixing types with AllowCreateProps, we need to come back to fix - TS-31874
            customCreatedItems.push.apply(customCreatedItems, currentlySelected.filter(function (item) { return item === null || item === void 0 ? void 0 : item.isCreateable; }));
        }
        if (customCreatedItems.length && useCheckboxSelection) {
            anchoredItems.push.apply(anchoredItems, customCreatedItems);
        }
        // Filtered items from `items`
        var filteredItems = items.filter(function (item) { return !inputText || renderItemToString(item).match(inputValueRegex); });
        var filteredItemsNotSelected = filteredItems.filter(function (item) {
            if (isSelectedAnArray) {
                var isItemSelected = currentlySelected.filter(function (selected) { return safelyCallItemToID(item) === safelyCallItemToID(selected); });
                return isItemSelected.length === 0 && item;
            }
            else {
                return currentlySelected ? safelyCallItemToID(item) !== safelyCallItemToID(currentlySelected) : item;
            }
        });
        // DO NOT remove selected items from the filtered list if using checkbox selection
        if (useCheckboxSelection) {
            // From all items: separate anchored and non-anchored items
            filteredItems.forEach(function (filteredItem) {
                var filteredItemIsAnchored = itemIsAnchored(filteredItem);
                if (filteredItemIsAnchored) {
                    anchoredItems.push(filteredItem);
                }
                else {
                    nonAnchoredItems.push(filteredItem);
                }
            });
        }
        else {
            // From non-selected items: separate anchored and non-anchored items
            filteredItemsNotSelected.forEach(function (filteredItem) {
                var filteredItemIsAnchored = itemIsAnchored(filteredItem);
                if (filteredItemIsAnchored) {
                    anchoredItems.push(filteredItem);
                }
                else {
                    nonAnchoredItems.push(filteredItem);
                }
            });
        }
        // Always set filtered anchored items, including selected
        // item if it's not an array and not using checkbox selection
        var updatedAnchoredItems = currentlySelected && !isSelectedAnArray && !useCheckboxSelection
            ? __spreadArray([currentlySelected], anchoredItems, true) : anchoredItems;
        /**
         * Update with filtered items based on input value,
         * combing filtered anchored items (which can dynamically
         * include selected items), and filtered non-anchored items.
         */
        setFilteredAnchoredItemsCount(updatedAnchoredItems.length);
        // @ts-expect-error - Already mixing types with AllowCreateProps, we need to come back to fix - TS-31874
        setListItems(__spreadArray(__spreadArray([], updatedAnchoredItems, true), nonAnchoredItems, true));
    };
    return {
        filteredAnchoredItemsCount: filteredAnchoredItemsCount,
        listItems: listItems,
        setListItems: setListItems,
        updateFilteredListboxItems: updateFilteredListboxItems,
    };
};
exports.useDetermineFilteredListItems = useDetermineFilteredListItems;
